import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import TelecallersMaster from './TelecallersMaster';
import LeadSourcesMaster from './LeadSourcesMaster';
import SkillLevelsMaster from './SkillLevelsMaster';

const MastersManagement = () => {
  const [activeMaster, setActiveMaster] = useState('telecallers');

  const masters = [
    { id: 'telecallers', label: 'Lead Callers', icon: 'Phone', description: 'Manage telecaller users' },
    { id: 'lead_sources', label: 'Lead Sources', icon: 'Link', description: 'Manage lead source options' },
    { id: 'skill_levels', label: 'Skill Levels', icon: 'BarChart3', description: 'Manage skill level options' }
  ];

  return (
    <div className="p-6">
      {/* Master Selection */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Select Master to Manage</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {masters.map(master => (
            <button
              key={master.id}
              onClick={() => setActiveMaster(master.id)}
              className={`p-4 border-2 rounded-lg text-left transition-all ${
                activeMaster === master.id
                  ? 'border-primary bg-primary/5'
                  : 'border-border hover:border-primary/50'
              }`}
            >
              <div className="flex items-center gap-3 mb-2">
                <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${
                  activeMaster === master.id ? 'bg-primary/10' : 'bg-muted'
                }`}>
                  <Icon 
                    name={master.icon} 
                    size={20} 
                    className={activeMaster === master.id ? 'text-primary' : 'text-muted-foreground'}
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-foreground">{master.label}</h4>
                  <p className="text-xs text-muted-foreground">{master.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Master Content */}
      <div className="border-t border-border pt-6">
        {activeMaster === 'telecallers' && <TelecallersMaster />}
        {activeMaster === 'lead_sources' && <LeadSourcesMaster />}
        {activeMaster === 'skill_levels' && <SkillLevelsMaster />}
      </div>
    </div>
  );
};

export default MastersManagement;

